import React from 'react'
import { smallGallery } from './mock'

export const Aboutus = () => {
    return (
        <div className="about-company mt-2em-">
                  <h3 className="">About us</h3>
                <p className="mb-3 mt-2">Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.</p>
                <ul className="">
                    {smallGallery.map((item,i)=>(
                        <li key={`about-gallery-${i}`}> 
                            <img src={`/assets/images/projects/${item.img}.jpg`} alt="" className="" /> 
                        </li>
                    ))}
                </ul>
         </div>
    )
}